import { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { useResetRecoilState } from 'recoil'

import Loading from '@/shared/components/common/Loading'
import SubScript from '@/shared/components/common/Subscript/SubScript'
import useSubscriptQuery from '@/shared/hooks/useSubscriptQuery'
import { CertNumState, TelNumState, TimeOutState, TranIdState } from '@/shared/store'
import { LoginWrap } from '@/styles/views/Login'
// import { NavLink } from 'react-router-dom'

const LoginPage = () => {
  const subscript = useSubscriptQuery()
  const ResetTelNum = useResetRecoilState(TelNumState)
  const ResetTimeOut = useResetRecoilState(TimeOutState)
  const ResetTranId = useResetRecoilState(TranIdState)
  const ResetCertNum = useResetRecoilState(CertNumState)
  useEffect(() => {
    return () => {
      ResetTelNum()
      ResetTimeOut()
      ResetTranId()
      ResetCertNum()
    }
  }, [ResetCertNum, ResetTelNum, ResetTimeOut, ResetTranId])

  return (
    <LoginWrap>
      {subscript.LoginIsLoading && <Loading />}
      <SubScript />
      <p>
        휴대폰가족보호 회원이 아니신가요?
        <NavLink to={'/join'}>회원가입</NavLink>
      </p>
    </LoginWrap>
  )
}
export default LoginPage
